import LoadingScreen from "@/components/shared/LoadingScreen";

import { useActiveThread } from "./hooks/useActiveThread";

export default function ThreadCommentListLoading({
  isLoading,
  children,
}: {
  isLoading?: boolean;
  children: React.ReactNode;
}) {
  const activeThread = useActiveThread();

  if (isLoading || activeThread?.commentFirstPhaseMsgListInit === false) {
    return (
      <div className="flex flex-1 items-center justify-center align-middle">
        <LoadingScreen
          title={"Loading comments history..."}
          className="bg-background"
        />
      </div>
    );
  }

  return <>{children}</>;
}
